module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.2981556a.jpg";